import { template } from './icons.html.js';

// ============================================================================
// Add the markup to the document.

import '@polymer/iron-iconset-svg/iron-iconset-svg.js';

// Add the markup to the document so it can be consumed by iron-iconset-svg (via iron-icon elements).
const container = document.createElement('div');
container.innerHTML = template;
document.body.appendChild(container);